import sharedColors from './sharedColors';

const palette = ({ accentColor }) => ({
  accent: accentColor,
  ...sharedColors
});
export default palette;
